export const DismissButtonLabel = "Dismiss {0} message";
export const Error = "error";
export const Info = "info";
export const Success = "success";
export const Warning = "warning";
